export default __webpack_public_path__ + "static/media/landingimage1.8a12a7df.png";